/**
 * « Trié par … » + lien vers la rubrique de classement (C. conso D111-6 II,
 * al. 2 : « sur chaque page de résultats, le critère de classement utilisé
 * ainsi que la définition de ce critère, y compris par renvoi à la rubrique »).
 * Une ligne discrète : l'information est due, pas un mur de texte.
 */
import React from "react";
import { Link } from "react-router-dom";
import { CRITERES_TRI, RUBRIQUE_CLASSEMENT } from "../utils/classementSponsorise";

export default function CritereClassement({ tri = "recent", className = "" }) {
  const c = CRITERES_TRI[tri] || CRITERES_TRI.recent;
  return (
    <p className={`text-xs text-slate-400 ${className}`} data-testid="critere-classement">
      {/* Une ligne (Lucas : « trop de texte »). La définition complète, et le
          sens des mentions « À la Une » / « Sponsorisé », vivent dans la
          rubrique — D111-6 II autorise ce renvoi. */}
      Trié par : {c.label.toLowerCase()} ({c.definition}) ·{" "}
      <Link to={RUBRIQUE_CLASSEMENT} className="underline hover:text-slate-600">En savoir plus</Link>
    </p>
  );
}
